import React, { useState } from 'react';
import type { FC, ReactNode } from 'react';
import { ConfirmInput, Text, useAsync, useExit } from '@wix/cli-ui-kit';
import { Trans, useTranslation } from '@wix/cli-i18n';
import { readUserConfig, updateUserConfig } from '@wix/cli-user-config';
import { match } from 'variant';
import { useBackendComponents } from '../../backend/useBackendComponents.js';

interface Props {
  children: ReactNode;
}

export const TunnelingConsent: FC<Props> = ({ children }) => {
  const exit = useExit();
  const { t } = useTranslation();
  const { backendComponents } = useBackendComponents();
  const [approved, setApproved] = useState<boolean>();

  const { status } = useAsync(async () => {
    const config = await readUserConfig();

    if (config.tunneling) {
      setApproved(true);
    }

    return config;
  }, []);

  if (backendComponents.length === 0 || approved) {
    return children;
  }

  return (
    <>
      {match(status, {
        Success: () => (
          <ConfirmInput
            label={t('dev_command.tunneling.confirm')}
            initialValue={true}
            onSubmit={async (approved) => {
              setApproved(approved);
              await updateUserConfig({ tunneling: approved });
              if (!approved) {
                exit();
              }
            }}
          />
        ),
        Error: () => null,
        Loading: () => null,
      })}
      {approved === false && (
        <Text skin="error">
          <Trans i18nKey="dev_command.tunneling.abort_dev" />
        </Text>
      )}
    </>
  );
};
